import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { CommonStore } from "@interfaces/index";

export const useCommonStore = create<CommonStore>()(
  devtools(
    (set) => ({
      isStateInitiated: false,
      isAuth: false,
      isLoading: false,
      isDrawerShown: false,
      isDomUpdated: false,
      setState: (state) => set(() => ({ ...state })),
      resetState: () =>
        set({
          isStateInitiated: true,
          isAuth: false,
          isLoading: false,
          isDrawerShown: false,
          isDomUpdated: false,
        }),
    }),
    { name: "common-storage", store: "common-storage" },
  ),
);
